// extracted by mini-css-extract-plugin
export default {"cls1":"VeloPhoneNumberField-CallingCode_cls1__oy6YQ","cls2":"VeloPhoneNumberField-CallingCode_cls2__8NQL7 VeloPhoneNumberField-CallingCode_cls1__oy6YQ"};